// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"fc93c4b0","122":"37c09bf4","239":"dac06248","263":"195f616c","453":"f88409ed","455":"7ac8d574","471":"da022dff","513":"718d6bdb","549":"21f038c5","821":"24191279","977":"e9d662d1"}[chunkId] + ".chunk.js";
};